module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//head-bg.png?v=394ea41c";